module.exports = __webpack_public_path__ + "img/shoucang.acc360ec.png";